module.exports = __webpack_public_path__ + "static/media/wiki.75b0f190.png";